import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <main className="flex min-h-dvh items-center justify-center">
        <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-[var(--color-border)] border-t-[var(--color-accent)]" />
      </main>
    );
  }

  return <Navigate to={isAuthenticated ? '/decks' : '/login'} />;
}
